import { render } from "./ActivityKPI.vue?vue&type=template&id=3979296c&ts=true"
import script from "./ActivityKPI.ts?vue&type=script&lang=ts"
export * from "./ActivityKPI.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__